import axios from 'axios';
import router from '../router';
import Vue from 'vue';

axios.defaults.withCredentials = true;
axios.defaults.headers['Content-Type'] = 'application/json';

const baseURL = process.env.BASE_API || window.location.origin;
// 创建axios实例
const service = axios.create({
    baseURL: baseURL, // api的base_url
    timeout: 30000                  // 请求超时时间
});
import {Message} from 'iview';
import Cookies from "js-cookie";
// request拦截器
service.interceptors.request.use(config => {
    return config;
}, error => {
    return Promise.reject(error);
});
// 引入i18n
import VueI18n from "vue-i18n"
    // 这里需要注册使用语言包
    Vue.use(VueI18n);
    Vue.locale = () => {
};
//引入iview提供的语言包
import zhLocale from "iview/src/locale/lang/zh-CN";
import enLocale from "iview/src/locale/lang/en-US";
import twLocale from "iview/src/locale/lang/zh-TW";

// 引入自定义的语言包
import cn from "@/language/zh-CN";
import tw from "@/language/zh-TW";
import us from "@/language/en-US";

// 自己写的语言包，并封装成对象
const messages = {
    zh: Object.assign(cn, zhLocale),
    en: Object.assign(us, enLocale),
    tc: Object.assign(tw, twLocale)
};
// 设置参数，创建 Vuei18n 的实例。需要将他挂载全局的所有组件上
const i18n = new VueI18n({
    // set locale 本地存储记录当前选中的语言是哪一种/默认的是哪种语言
    locale: localStorage.getItem("language") || "zh",
    messages, // set locale messages,在构造器中配置这个语言包
    silentTranslationWarn: true
});


const validVue = Vue.extend({i18n});
// respone拦截器
service.interceptors.response.use(
    response => response,
    error => {
        if (error.response == undefined) {
            return Promise.reject(error);
        }
        if (error.response.data.error == 'Unauthenticated.' || error.response.data.error == 'Uncertified' || error.response.data.message== 'Uncertified') {
            return new Promise((resolve, reject) => {
                Message.destroy();
                Message.info(new validVue().$t('noticeAccountExpired'));
                Cookies.set('uid', '');
                Cookies.set('acc', '');
                router.replace({
                    path: '/login'
                });
                setTimeout(() => {
                    window.location.reload();
                    return;
                }, 5000);
            });
        } else {
            return Promise.reject(error.response.data);
        }
    }
)
export default service;



// WEBPACK FOOTER //
// ./src/utils/fetch.js